import {Howl, Howler} from 'howler';

export const muteAll = (isM)=>{
    Howler.mute(isM)
    // Howler.mute(isM)
}
export const moveSound = new Howl({
    src: ['/assets/sounds/Move-Right-v1.mp3'],
    autoplay: false,
    loop: false,
    volume: 0.07,
});

export const fallingSound = new Howl({
    src: ['/assets/sounds/Pieces-Dropping-v1.mp3'],
    autoplay: false,
    loop: false,
    volume: 0.03,
});

export const rotateSound = new Howl({
    src: ['/assets/sounds/Spinning-Piece-v3.mp3'],
    autoplay: false,
    loop: false,
    volume: 0.05,
});

export const matchPairSound = new Howl({
    src: ['/assets/sounds/Match-Piece-Disappear-v3-r1.mp3'],
    autoplay: false,
    loop: false,
    volume: 0.1,
});

export const frezzeCellSound = new Howl({
    src: ['/assets/sounds/Set-in-Place-v1.mp3'],
    autoplay: false,
    loop: false,
    volume: 0.1,
});

export const gamePlayMusic = new Howl({
    src: ['/assets/sounds/Gameplay-Music.mp3'],
    autoplay: false,
    loop: true,
    // volume: 0.0,
    volume: 0.05,
    onfade: function(e){
        this.stop();
        this.volume(0.05);
    }
});

export const titleScreenMusic = new Howl({
    src: ['/assets/sounds/Title-Screen-Music.mp3'],
    autoplay: false,
    loop: true,
    volume: 0.05,
    // volume: 0.0,
    onfade: function(e){
        this.stop();
        this.volume(0.05);
    }
});